module.exports = __webpack_public_path__ + "img/Jump Casting103.f8448682.jpg";